<template>
  <div class="post-detail-page">
    <van-nav-bar
      fixed
      placeholder
      border
      left-arrow
      safe-area-inset-top
      title="班车信息"
      @click-left="back"
    />
    <div class="page-content-wrapper">
     
       <img :src=imgurl class="img" @click="openImg()">
    </div>
  </div>
</template>

<script>

import { ImagePreview } from 'vant'; 
export default {
  name: 'Bctime',
  data() {
    return {
      imgurl: '',
    };
  },
  created(){
         this.imgurl="http://hqapp1.bit.edu.cn/images/bctime.jpg?v="+Math.random();
  },
  mounted() {
        
  },
  methods: {
    
    back() {
      this.$router.back();
    },
     openImg() {
       let thant = this
      ImagePreview({
        images:[thant.imgurl],
         closeable: true    
      });
    },

  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variable.scss";
@import "~@/assets/styles/mixins.scss";

::v-deep .van-nav-bar__text {
  color: #fff;
}

.page-content-wrapper {
  height: calc(100vh - 46px);
 
 .img{width:100%}
  
}

</style>
